import vm from '@/main'

const i18n = vm.$t('_formCustom.components') || {}
export default [
  {
    title: i18n.inputField,
    tooltip: i18n.inputFieldTip,
    items: [
      {
        label: i18n.lineText,
        icon: 'rectangle-one',
        formOption: {
          type: 'input',
          value: '',
        },
      },
      {
        label: i18n.number,
        icon: 'rectangle-one',
        formOption: {
          type: 'number',
          value: '',
        },
      },
      {
        label: i18n.password,
        icon: 'file-lock',
        formOption: {
          type: 'password',
        },
      },
      {
        label: i18n.mLineText,
        icon: 'align-text-left-one',
        formOption: {
          type: 'textarea',
          value: '',
        },
      },
      {
        label: i18n.slider,
        icon: 'auto-width',
        formOption: {
          type: 'slider',
          numberMax: 10,
          numberMin: 1,
        },
      },
      {
        label: i18n.editor,
        icon: 'word',
        formOption: {
          type: 'editor',
        },
      },
    ],
  },
  {
    title: i18n.selectField,
    tooltip: i18n.selectFieldTip,
    items: [
      {
        label: i18n.select,
        tooltip: i18n.selectTip,
        icon: 'drop-down-list',
        formOption: {
          type: 'select',
        },
      },
      {
        label: i18n.radio,
        icon: 'radio-two',
        formOption: {
          type: 'radio',
        },
      },
      {
        label: i18n.check,
        icon: 'checkbox',
        formOption: {
          type: 'check',
        },
      },
      {
        label: i18n.checkbox,
        icon: 'checkbox',
        formOption: {
          type: 'checkbox',
        },
      },
      {
        label: i18n.time,
        icon: 'custom-time',
        formOption: {
          type: 'time',
        },
      },
      {
        label: i18n.date,
        icon: 'calendar-thirty',
        formOption: {
          type: 'date',
        },
      },
      {
        label: i18n.dateTime,
        icon: 'calendar-dot',
        formOption: {
          type: 'dateTime',
        },
      },
      {
        label: i18n.year,
        icon: 'schedule',
        formOption: {
          type: 'year',
        },
      },
      {
        label: i18n.month,
        icon: 'calendar-thirty-two',
        formOption: {
          type: 'month',
        },
      },
      {
        label: i18n.switch,
        icon: 'power',
        formOption: {
          type: 'switch',
        },
      },
      {
        label: i18n.file,
        icon: 'file-addition',
        formOption: {
          type: 'upload',
        },
      },
    ],
  },
  {
    title: i18n.customField,
    tooltip: i18n.customFieldTip,
    items: [
      {
        label: i18n.staffSelect,
        icon: 'drop-down-list',
        formOption: {
          type: 'select',
          dictCode: 'staff',
        },
      },
      {
        label: i18n.workerSelect,
        icon: 'drop-down-list',
        formOption: {
          type: 'select',
          dictCode: 'worker',
        },
      },
    ],
  },
]
